import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '..';

const query = gql`
query investmentAnswers(
  $id : Int,
) {
  allNpoReportAnswers(filters: {investmentId: $id}) {
    edges {
      node {
        dbId
        reportId
        questionId
        investmentId
        text
        answerId
        answerTime
        answerUserId
        answerErrors
        answerWarnings
        timeOnQuestions
        question {
          dbId
          text
          section
          questionType
          nextQuestionId
        }
        enumResponse {
          dbId
          response
          responseType
          nextQuestionId
          treeGroup
        }
        answerValidations {
          edges {
            node {
              validationId
              hidden
            }
          }
        }
      }
    }
  }
}`;

export const useInvestmentAnswers = (investmentId) => {
  if (!investmentId) {
    return { data: [], refetch: () => { /* noop */ }, loading: false };
  }
  const { data: rawData, refetch, loading } = useQuery(query, {
    variables: { id: investmentId },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });
  const data = removeConnectionsMemoized(rawData?.allNpoReportAnswers);
  return { data, refetch, loading };
};
